module.exports = __webpack_public_path__ + "static/media/Albania.dbae9d38.png";